import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const CustomizationSection = ({ 
  specialInstructions, 
  onInstructionsChange,
  customizations,
  onCustomizationChange 
}) => {
  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Edit3" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
            Customization Options
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Add your preferences and special requests
          </p>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div>
          <label className="block text-sm md:text-base font-medium text-foreground mb-3">
            Spice Level
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3">
            {customizations?.spiceLevels?.map((level) => (
              <button
                key={level?.value}
                onClick={() => onCustomizationChange('spiceLevel', level?.value)}
                className={`flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg border-2 transition-smooth ${
                  customizations?.selectedSpiceLevel === level?.value
                    ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50'
                }`}
              >
                <span className="text-2xl md:text-3xl">{level?.emoji}</span>
                <span className="text-xs md:text-sm font-medium text-foreground">
                  {level?.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <Input
            label="Special Instructions"
            type="text"
            placeholder="E.g., Extra sauce on the side, no onions, well-done..."
            value={specialInstructions}
            onChange={(e) => onInstructionsChange(e?.target?.value)}
            description="Let the chef know your specific preferences (optional)"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomizationSection;